'use client';

import { useAppPathname } from '../../../shared/router/AppRouterContext';

import Pagination from '../../../container/pagination/Pagination';

import {
  type ChangeContentBlockProductsPageAtomPromise,
  contentBlockProductsLastPageLoadedAtomFamily,
  createContentBlockProductsPageKey,
} from '@vs-shop/engine/atom/products/contentBlockProductsPagination';
import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';

type Props = {
  blockIndex: number;
  hydraViewExtended: HydraViewExtended;
  changePage: ChangeContentBlockProductsPageAtomPromise;
  scrollToProductsGrid: () => void;
};

export default function ContentBlockProductsPagination({
  blockIndex,
  hydraViewExtended,
  changePage,
  scrollToProductsGrid,
}: Props) {
  const pathname = useAppPathname();
  const pageKey = createContentBlockProductsPageKey(blockIndex);
  const lastPageLoadedAtom = contentBlockProductsLastPageLoadedAtomFamily(pageKey);

  return (
    <Pagination
      hydraViewExtended={hydraViewExtended}
      changePage={changePage}
      scrollToGrid={scrollToProductsGrid}
      baseUrl={pathname}
      lastPageLoadedIncludingLoadMoreAtom={lastPageLoadedAtom}
    />
  );
}
